import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { List, Box, ListSubheader } from "@mui/material";
// hooks
import useLocales from "src/hooks/useLocales";
//
import { NavListRoot } from "./NavList";
import Iconify from "../../Iconify";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation } from "react-router";

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function NavSectionVertical({ isCollapse = false, ...other }) {
  const { translate } = useLocales();

  const query = useQuery();
  const reviewProgram = query.get("review-program");

  const navConfig = [
    {
      subheader: translate(
        "componentsTranslations.navBarTranslations.overview.title"
      ),
      items: [
        {
          title: translate(
            "componentsTranslations.navBarTranslations.overview.links.home"
          ),
          path: `/welcome/home${reviewProgram ? "?review-program=true" : ""}`,
          icon: <HomeIcon />,
        },
        {
          title: translate(
            "componentsTranslations.navBarTranslations.overview.links.meals"
          ),
          path: `/overview/nutrition-plan${
            reviewProgram ? "?review-program=true" : ""
          }`,
          icon: <Iconify icon="game-icons:hot-meal" />,
        },
        {
          title: translate(
            "componentsTranslations.navBarTranslations.overview.links.supplements"
          ),
          path: `/overview/supplements${
            reviewProgram ? "?review-program=true" : ""
          }`,
          icon: <Iconify icon="icon-park-solid:medicine-bottle-one" />,
        },
        {
          title: translate(
            "componentsTranslations.navBarTranslations.overview.links.workout"
          ),
          path: `/overview/workout${
            reviewProgram ? "?review-program=true" : ""
          }`,
          icon: <Iconify icon="arcticons:home-workouts" />,
        },
        {
          title: translate(
            "componentsTranslations.navBarTranslations.overview.links.explanation"
          ),
          path: `/overview/explanation`,
          icon: <Iconify icon="mingcute:youtube-fill" />,
        },
      ],
    },
    {
      subheader: translate(
        "componentsTranslations.navBarTranslations.support.title"
      ),
      items: [
        /*  {
          title: translate(
            "componentsTranslations.navBarTranslations.support.links.requestSupport"
          ),
          path: "/support/request-support",
          icon: (
            <Iconify icon="streamline:interface-help-customer-support-1-customer-headset-help-microphone-phone-support" />
          ),
        }, */
        {
          title: translate(
            "componentsTranslations.navBarTranslations.support.links.bugReport"
          ),
          path: "/support/bug-report",
          icon: <Iconify icon="material-symbols:chat-error-outline-rounded" />,
        },
        {
          title: translate(
            "componentsTranslations.navBarTranslations.support.links.inquiries"
          ),
          path: "/support/inquires",
          icon: <Iconify icon="line-md:email" />,
        },
      ],
    },
  ];
  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }}>
          <ListSubheaderStyle
            sx={{
              ...(isCollapse && {
                opacity: 0,
              }),
            }}
          >
            {group.subheader}
          </ListSubheaderStyle>

          {group.items.map((list) => (
            <NavListRoot
              key={list.title + list.path}
              list={list}
              isCollapse={isCollapse}
            />
          ))}
        </List>
      ))}
    </Box>
  );
}
